"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEEK_IN_MS = exports.NO_END_DATE = exports.NO_END = exports.NO_START = exports.DATE_RANGE_FORMAT = void 0;
var DATE_RANGE_FORMAT = 'D MMM YYYY';
exports.DATE_RANGE_FORMAT = DATE_RANGE_FORMAT;
var NO_START = '0001-01-01T00:00:00Z';
exports.NO_START = NO_START;
var NO_END = '9999-12-31T00:00:00Z';
exports.NO_END = NO_END;
var NO_END_DATE = '9999-12-31';
exports.NO_END_DATE = NO_END_DATE;
var WEEK_IN_MS = 7 * 24 * 60 * 60 * 1000;
exports.WEEK_IN_MS = WEEK_IN_MS;